import { render, staticRenderFns } from "./perpson.vue?vue&type=template&id=1eeb449c&scoped=true"
import script from "./perpson.vue?vue&type=script&lang=js"
export * from "./perpson.vue?vue&type=script&lang=js"
import style0 from "./perpson.vue?vue&type=style&index=0&id=1eeb449c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eeb449c",
  null
  
)

export default component.exports